import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';
import { WorkspaceService } from 'src/app/core/services/workspace.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'vcp-workspace-card',
  templateUrl: './workspace-card.component.html',
  styleUrls: ['./workspace-card.component.scss'],
})
export class WorkspaceCardComponent implements OnInit {
  showInfo = true;

  @Input() config;
  @Input() workspaceList;
  @Input() workspaceType;
  @Output() action = new EventEmitter<object>();
  searchValue;
  constructor() {}


  ngOnInit(): void {}

  applyFilter(event) {
    this.searchValue = (event.target as HTMLInputElement).value;
  }

  cardAction(e) {
    const targetElem = e.target; // This will be the element where user clicked
    let type = '';
    const listElem = targetElem.closest('.child-card'); // getting the list from closest
    if (!listElem) return;
    const index = listElem.dataset.index; // retrieving data-set
    if(targetElem.textContent =="Not Now"){
      type = "not-now";
    }
    else if(targetElem.textContent =="Accept"){
      type = "accept";
    }
    else if(targetElem.textContent.toLowerCase().trim() == "set as default"){
      type = "default";
    }

    else{
    type = listElem.dataset.type;
    }
    if (!index && !type) return;
    this.statusAction(index, type);
  }

  statusAction(index: number, type) {
    const workspace = this.workspaceList[index];
    this.workspaceType = workspace.type;
    this.action.emit({
      workspace,
      index,
      type,
      workspaceType: this.workspaceType ? this.workspaceType : null,
    });
  }

  stopPropagation() {
    event.stopPropagation();
  }
  toggleInfo(index) {
    event.stopPropagation();
    const elem: HTMLElement = document.getElementById(`showOption${index}`);
    if (elem.classList.contains('display-block')) {
      elem.classList.remove('display-block');
    } else {
      elem.classList.add('display-block');
    }
  }
}
